<script setup>
    import { ref, onMounted, watch } from 'vue'
    import { useRoute } from 'vue-router'
    import Api from '../services/api'
    import { useAuthStore } from '../stores/useAuthStore'
    import { useUiStore } from '../stores/useUiStore'
    import { useAppStore } from '../stores/useAppStore.js'
    
    import LayoutTopBar from './layouts/LayoutTopBar.vue'
    import LayoutBottomNav from './layouts/LayoutBottomNav.vue'
    import ProgressSpinner from 'primevue/progressspinner'
    import { useAccountingStore } from '../stores/useAccountingStore'
    import { useNotifStore } from '../stores/useNotifStore'

    const route = useRoute()
    const authStore = useAuthStore()
    const { isAuth } = authStore
    const uiStore = useUiStore()
    const { loading } = uiStore
    const accStore = useAccountingStore()
    const notifStore = useNotifStore()
    const appState = useAppStore()

    const isInitializing = ref(false)
    const initialized = ref(false)

    const getProfile = async () => {
        const response = await Api.post('profile')
        authStore.setProfile(response.data)
    }

    const initSetting = async () => {
        const response = await Api.get('ref/setting')
        accStore.setTax(response.data.tax_value)
    }

    const getNotification = async () => {
        try {
            const response = await Api.get('notifications')
            notifStore.setItem(response.data.data)
        } catch (error) {
            console.error(error)
        }
    }

    async function handleAuthenticated() {
        if (initialized.value || isInitializing.value) return

        isInitializing.value = true

        try {
            await Promise.allSettled([getProfile(), getNotification()])
            initialized.value = true
        } finally {
            isInitializing.value = false
        }
    }

    function handleUnauthenticated() {
        initialized.value = false
    }

    watch(
        isAuth,
        async (val) => {
            const app = document.getElementById('smp-app')
            if (!app) return

            if (val) {
                app.classList.remove('need-auth')
                await handleAuthenticated()
            } else {
                app.classList.add('need-auth')
                handleUnauthenticated()
            }
        },
        { immediate: true }
    )

    onMounted(() => {
        initSetting().catch(console.error)
    })

</script>
<template>
    <div class="wrapper-loader" v-if="loading">
        <ProgressSpinner aria-label="Loading" class="center-page" />
    </div>

    <div id="app-section" :class="['app-section', isAuth ? 'bg-white' : 'auth-register']">
        <template v-if="isAuth">
            <LayoutTopBar />

            <div id="content">
                <router-view />
            </div>

            <LayoutBottomNav v-if="!['shopping.cart','account','shopping.checkout','shopping.detail','shopping.delivery','account.hutang'].includes(route.name)" />
        </template>

        <template v-else>
            <template v-if="!appState.app_member_active.value">
                <router-view />
            </template>
            <div id="login-section" class="section-auth" v-else>
                <router-view />
            </div>
        </template>
    </div>
</template>